import { BottomNavHomeIcon, BottomNavMyIcon, BottomNavSearchIcon, BottomNavTreatmentCaseIcon } from "../ui/atoms"

export const BOTTOM_NAV_ICON_MAP = {
  home: BottomNavHomeIcon,
  search: BottomNavSearchIcon,
  treatmentCase: BottomNavTreatmentCaseIcon,
  my: BottomNavMyIcon,
} as const

